import { BaseKey, useNavigation, useSelect, useShow } from '@refinedev/core';
import { Modal, Button, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import Cw8Edit from 'components/cw8/Cw8Edit';
import Cw8List from 'components/cw8/Cw8List';
import { ChildForm, ConfigCard, FieldDB, TableDB } from 'interfaces/schemaDB';
import React from 'react'
// import Cw8Edit from './Cw8Edit';
// import Cw8List from './Cw8List';
import { useSchemaDB } from '../../../src/hooks/useSchemaDB';
import { CrudFilters, Option } from '@refinedev/core/dist/interfaces';

import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import { Typography, Form, Dropdown, Space, Select } from 'antd';
import { CreateButton , useForm, useModalForm } from '@refinedev/antd';

import { Col, Row } from 'antd';
import Cw8Field from 'components/cw8/Cw8Field';
// import { FieldDB } from 'src/interfaces/schemaDB';
import { FormMode } from 'interfaces/interfaces';
import useState from 'react';

// import { Select } from 'antd';
import useEffect from 'react';
import SeccionInfografia from './SeccionInfografia';
import SubSeccionInfografia from './SubSeccionInfografia';
import { MenuSeccion } from './MenuSeccion';
import Cw8Create from 'components/cw8/Cw8Create';
import { config } from 'config';
// import SeccionInfografia from 'src/pages/infografias/SeccionInfografia';

const { Title } = Typography;
interface EditInfografiaProps{
    resourceLabel ?: string
    resourceName :string
    id : BaseKey | undefined 
    childrenForms : ChildForm[]
}

interface BtnExtraProps{
    childrenForms : ChildForm[]
}



const EditInfografia = ({resourceLabel, resourceName, id, childrenForms} : EditInfografiaProps ) => {


    
    let ID : any = id



    const resourceNameSeccion = "seccionInfografia"
    const filterList : CrudFilters  =  [
        {
            field: "sec_id_infografia",
            operator: "eq",
            value: ID
        },
    ]

    const {         
        modalProps: createModalProps,
        formProps: createFormProps,
        show: openModalCreate} = useModalForm({
            action: "create",
            resource:resourceNameSeccion,
            redirect : false
        }
    );

    const { queryResult } = useShow();
    const { data, isLoading } = queryResult;
    const record = data?.data;    
        
    const {
        modalProps: editModalProps,
        formProps: editFormProps,
        show: editModalShow,
    } = useModalForm({
        action: "edit"
        , resource: 'infografia'
        , redirect: false
    });

    const extraContent = (
        <div>
    
            <Button 
                onClick={ ()=> editModalShow(id)}
            >Editar Infografía
            </Button>
    
            <a href={`${config.urlAPI}/publicar/infografia/${id}`} target="_blank" rel="noreferrer">
                <Button>Generar Json</Button>
            </a>
            <a href={`${config.urlSiteinfografia}/${id}`} target="_blank" rel="noreferrer">
                <Button>Ver Infografía</Button>
            </a>
        </div>
    );    

    if(childrenForms.length == 0){
        return(
            <Cw8Edit resourceName = {resourceName} childrenForms={childrenForms} ></Cw8Edit>
        )
    }else{
        return(
            <>
            
            <Title level={4}>Infografía: {record?record["inf_nombre"]:""}</Title>
            
            <Tabs defaultActiveKey="0" 
                tabBarExtraContent={extraContent}
            >
                <TabPane tab={"Infografía"} key={0}>
                    <MenuSeccion
                        idInfografia = {ID}
                        // setSeccion = {setIdSection}
                    ></MenuSeccion>
                </TabPane>                
                
                {/* <TabPane tab={resourceLabel?resourceLabel:"General"} key="1">
                    <Cw8Edit resourceName = {resourceName}  childrenForms={childrenForms}></Cw8Edit>
                </TabPane> */}

                {
                    childrenForms.filter( item => !item.url ).map( (child, index) =>(
                        <TabPane tab={child.title} key={index+2}>
                            <Cw8List
                                resourceName = {child.resourceName}
                                titleList = {child.title}
                                filterList ={[
                                    {
                                        field: child.field,
                                        operator: "eq",
                                        value: ID
                                    }
                                ]}
                                showCards = {child.showCards?true:false}
                                configCard = {
                                    child.configCard?child.configCard:undefined
                                }
                                createModal = {true}
                                editModal = {true}
                            ></Cw8List>        
                        </TabPane>
                    ))
                }
            </Tabs>   

            <Modal {...createModalProps}>
                <Cw8Create
                    resourceName={resourceNameSeccion}
                    filterList = {filterList}
                    createFormProps = {createFormProps}
                ></Cw8Create>
            </Modal>

            <Modal {...editModalProps}
                title="Editar Infografia"
            >
                <Cw8Edit
                    key={id}
                    resourceName={'infografia'}
                    editFormProps={editFormProps}
                    idResource={id}
                    modal={true}
                ></Cw8Edit>
            </Modal>

            </>            
        )
    }
        
}

export default EditInfografia
